var map = {
	"./drink1.jpg": 7056,
	"./drink2.jpg": 1407,
	"./drink3.jpg": 3346,
	"./drink4.jpg": 7953,
	"./drink5.jpg": 3620,
	"./drink6.jpg": 9683,
	"./drink7.jpg": 198,
	"./drink8.jpg": 3093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5022;